import axios from "axios";

const fetchApprovers = (company_id, params, config) => {
  return axios.get(`/api/v1/companies/${company_id}/approvers`, {
    params,
    ...config,
  });
};

const fetchTargetApprover = (company_id, target, target_id, params, config) => {
  return axios.get(
    `/api/v1/companies/${company_id}/approvers/${target}/${target_id}/approver`,
    { params, ...config },
  );
};

const fetchTargetVerificators = (
  company_id,
  target,
  target_id,
  params,
  config,
) => {
  return axios.get(
    `/api/v1/companies/${company_id}/approvers/${target}/${target_id}/verificators`,
    { params, ...config },
  );
};

const fetchApproversList = (company_id, params, config) => {
  return axios.get(`/api/v1/companies/${company_id}/approvers/list_to_assign`, {
    params,
    ...config,
  });
};

const assignApprover = (
  company_id,
  approver_id,
  target_name,
  target_id,
  role,
) => {
  return axios.post(
    `/api/v1/companies/${company_id}/approvers/${approver_id}/assign/${target_name}/${target_id}/${role}`,
  );
};

const deassignApprover = (
  company_id,
  approver_id,
  target_name,
  target_id,
  role,
) => {
  return axios.post(
    `/api/v1/companies/${company_id}/approvers/${approver_id}/deassign/${target_name}/${target_id}/${role}`,
  );
};

const createApprover = (company_id, params) => {
  return axios.post(`/api/v1/companies/${company_id}/approvers`, params);
};

const updateApprover = (company_id, approver_id, params) => {
  return axios.patch(
    `/api/v1/companies/${company_id}/approvers/${approver_id}`,
    params,
  );
};

const deleteApprover = (company_id, approver_id) => {
  return axios.delete(
    `/api/v1/companies/${company_id}/approvers/${approver_id}`,
  );
};

const fetchApprovalFlows = (company_id, params, config) => {
  return axios.get(`/api/v1/companies/${company_id}/approval_flows`, {
    params,
    ...config,
  });
};

const upApprovalFlow = (company_id, approval_flow_id) => {
  return axios.patch(
    `/api/v1/companies/${company_id}/approval_flows/${approval_flow_id}/up`,
  );
};

const downApprovalFlow = (company_id, approval_flow_id) => {
  return axios.patch(
    `/api/v1/companies/${company_id}/approval_flows/${approval_flow_id}/down`,
  );
};

const deleteApprovalFlow = (company_id, approval_flow_id) => {
  return axios.delete(
    `/api/v1/companies/${company_id}/approval_flows/${approval_flow_id}`,
  );
};

const createApprovalFlow = (company_id, params) => {
  return axios.post(`/api/v1/companies/${company_id}/approval_flows`, params);
};

const exportApprovalSettings = (company_id) => {
  return axios({
    url: `/api/v1/companies/${company_id}/approvers/export`,
    method: "GET",
    responseType: "blob",
  });
};

const importApprovalSettings = (company_id, file) => {
  return axios.post(`/api/v1/companies/${company_id}/approvers/import`, file, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const ApiApprovers = {
  fetchApprovers,
  fetchApproversList,
  createApprover,
  updateApprover,
  deleteApprover,
  assignApprover,
  deassignApprover,
  fetchApprovalFlows,
  upApprovalFlow,
  downApprovalFlow,
  deleteApprovalFlow,
  createApprovalFlow,
  fetchTargetApprover,
  fetchTargetVerificators,
  exportApprovalSettings,
  importApprovalSettings,
};

export default ApiApprovers;
